import Repository from "@crly/repositories/repository.js";
import Path from "@crly/repositories/apiPath";

export default {
  /**
   * SID のログインパス
   * @param {*} params
   * @returns
   */
  getSoftBankLoginPath(params) {
    return Repository.get(Path.getSoftBankLoginPath, params);
  },
   /**
   * ログアウト
   */
   getSoftBankLogout() {
    return Repository.get(Path.getSoftBankLogoutPath);
  }
};
